import React, { forwardRef } from 'react';

const RecipeTypeFiltersIcon = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z"
        fill="#E3E9FF"
      />
      <path
        d="M19 7.515V16.486C18.9992 17.1527 18.7339 17.7918 18.2624 18.2631C17.7909 18.7345 17.1517 18.9995 16.485 19H7.515C6.84814 18.9995 6.20875 18.7343 5.73721 18.2628C5.26567 17.7912 5.00053 17.1519 5 16.485V7.515C5.00053 6.84814 5.26567 6.20875 5.73721 5.73721C6.20875 5.26567 6.84814 5.00053 7.515 5H16.486C17.1527 5.00079 17.7918 5.26605 18.2631 5.73756C18.7345 6.20907 18.9995 6.84832 19 7.515Z"
        fill="#ECF9FD"
      />
      <path
        d="M19 7.515V16.486C18.9992 17.1527 18.7339 17.7918 18.2624 18.2631C17.7909 18.7345 17.1517 18.9995 16.485 19H12V5H16.485C17.1518 5.00053 17.7912 5.26567 18.2628 5.73721C18.7343 6.20875 18.9995 6.84814 19 7.515Z"
        fill="#D9F3FC"
      />
      <path
        d="M16.8318 15.9261H7.16884C7.05957 15.9261 6.95478 15.8827 6.87751 15.8054C6.80025 15.7281 6.75684 15.6233 6.75684 15.514C6.75684 15.4048 6.80025 15.3 6.87751 15.2227C6.95478 15.1455 7.05957 15.1021 7.16884 15.1021H16.8318C16.9411 15.1021 17.0459 15.1455 17.1232 15.2227C17.2004 15.3 17.2438 15.4048 17.2438 15.514C17.2438 15.6233 17.2004 15.7281 17.1232 15.8054C17.0459 15.8827 16.9411 15.9261 16.8318 15.9261Z"
        fill="#00357B"
      />
      <path
        d="M16.831 15.9261H12V15.1021H16.831C16.9403 15.1021 17.045 15.1455 17.1223 15.2227C17.1996 15.3 17.243 15.4048 17.243 15.514C17.243 15.6233 17.1996 15.7281 17.1223 15.8054C17.045 15.8827 16.9403 15.9261 16.831 15.9261Z"
        fill="#001737"
      />
      <path
        d="M16.79 12.37H7.12804C7.02241 12.3648 6.92283 12.3192 6.84991 12.2426C6.77699 12.166 6.73633 12.0643 6.73633 11.9585C6.73633 11.8527 6.77699 11.751 6.84991 11.6744C6.92283 11.5978 7.02241 11.5522 7.12804 11.547H16.791C16.8967 11.5523 16.9962 11.5981 17.069 11.6748C17.1418 11.7515 17.1824 11.8532 17.1822 11.959C17.1821 12.0647 17.1413 12.1664 17.0683 12.2429C16.9953 12.3194 16.8957 12.3649 16.79 12.37Z"
        fill="#00357B"
      />
      <path
        d="M16.79 12.37H12V11.547H16.79C16.8956 11.5522 16.9952 11.5978 17.0681 11.6744C17.141 11.751 17.1817 11.8527 17.1817 11.9585C17.1817 12.0643 17.141 12.166 17.0681 12.2426C16.9952 12.3192 16.8956 12.3648 16.79 12.37Z"
        fill="#001737"
      />
      <path
        d="M16.7898 8.85696H7.12782C7.01855 8.85696 6.91376 8.81355 6.83649 8.73629C6.75923 8.65903 6.71582 8.55423 6.71582 8.44496C6.71582 8.33569 6.75923 8.2309 6.83649 8.15363C6.91376 8.07637 7.01855 8.03296 7.12782 8.03296H16.7908C16.9001 8.03309 17.0048 8.07663 17.082 8.15398C17.1592 8.23134 17.2025 8.33619 17.2023 8.44546C17.2022 8.55473 17.1587 8.65947 17.0813 8.73664C17.0039 8.81381 16.8991 8.85709 16.7898 8.85696Z"
        fill="#00357B"
      />
      <path
        d="M16.79 8.85696H12V8.03296H16.79C16.8993 8.03296 17.0041 8.07637 17.0813 8.15363C17.1586 8.2309 17.202 8.33569 17.202 8.44496C17.202 8.55423 17.1586 8.65903 17.0813 8.73629C17.0041 8.81355 16.8993 8.85696 16.79 8.85696Z"
        fill="#001737"
      />
      <path
        d="M14.6352 13.29C15.3477 13.29 15.9252 12.7124 15.9252 12C15.9252 11.2875 15.3477 10.71 14.6352 10.71C13.9228 10.71 13.3452 11.2875 13.3452 12C13.3452 12.7124 13.9228 13.29 14.6352 13.29Z"
        fill="#58B354"
      />
      <path
        d="M15.9252 12C15.9247 12.3419 15.7886 12.6697 15.5468 12.9115C15.305 13.1534 14.9772 13.2894 14.6353 13.29V10.71C14.9772 10.7105 15.305 10.8466 15.5468 11.0884C15.7886 11.3302 15.9247 11.658 15.9252 12Z"
        fill="#00A963"
      />
      <path
        d="M11.1211 16.804C11.8335 16.804 12.4111 16.2264 12.4111 15.514C12.4111 14.8016 11.8335 14.224 11.1211 14.224C10.4086 14.224 9.83105 14.8016 9.83105 15.514C9.83105 16.2264 10.4086 16.804 11.1211 16.804Z"
        fill="#FFEC00"
      />
      <path
        d="M12.4121 15.513C12.4115 15.855 12.2755 16.1828 12.0337 16.4246C11.7919 16.6664 11.464 16.8025 11.1221 16.803V14.223C11.464 14.2236 11.7919 14.3596 12.0337 14.6014C12.2755 14.8432 12.4115 15.1711 12.4121 15.513Z"
        fill="#FFD92E"
      />
      <path
        d="M9.3652 9.77604C10.0776 9.77604 10.6552 9.19849 10.6552 8.48604C10.6552 7.7736 10.0776 7.19604 9.3652 7.19604C8.65275 7.19604 8.0752 7.7736 8.0752 8.48604C8.0752 9.19849 8.65275 9.77604 9.3652 9.77604Z"
        fill="#FF2828"
      />
      <path
        d="M10.6551 8.48702C10.6549 8.82445 10.5226 9.14839 10.2866 9.3895C10.0505 9.6306 9.72944 9.76971 9.39209 9.77702V7.19702C9.72944 7.20434 10.0505 7.34344 10.2866 7.58455C10.5226 7.82565 10.6549 8.1496 10.6551 8.48702Z"
        fill="#CC0000"
      />
    </svg>
  );
});

export default RecipeTypeFiltersIcon;
